webpackJsonp([1],{

/***/ "CYbX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bagels"},[_c('h1',[_vm._v("Are there bagels today?")]),_vm._v(" "),_c('div',{staticClass:"answer",class:[_vm.answerColorClass, {loading: _vm.isAwaitingData}]},[_vm._v(_vm._s(_vm.answerContent))]),_vm._v(" "),_c('div',{staticClass:"next-container"},[_c('h2',[_vm._v("Next Bagel Day")]),_vm._v(" "),_c('div',{staticClass:"next-date",class:[_vm.nextDateColorClass, {loading: _vm.isAwaitingData}]},[_vm._v(_vm._s(_vm.nextDateContent))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),(_vm.dataError)?_c('div',{staticClass:"data-error"},[_vm._v("An error occurred when trying to load bagel data. Please try again later.")]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-container"},[_c('p',[_c('a',{attrs:{"href":"/list"}},[_vm._v("See all bagel days")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback-container"},[_c('p',[_c('a',{attrs:{"href":"/feedback"}},[_vm._v("Report a problem or leave feedback")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":"/static/logo.png","alt":"Pit Crew Logo"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IJl4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KAIx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a2cea52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("IJl4");
function injectStyle (ssrContext) {
  __webpack_require__("wuJh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a2cea52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bagels_vue__ = __webpack_require__("Wac/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29201cb3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bagels_vue__ = __webpack_require__("CYbX");
function injectStyle (ssrContext) {
  __webpack_require__("KAIx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bagels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29201cb3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bagels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Wac/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__webpack_require__("p5k0").shim();

window.Promise = __webpack_require__("ju79");

var axios = __webpack_require__("mtWM");

var queryParams = getParams(window.location.search);

function getParams(query) {
  // https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript

  if (!query) {
    return {};
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {});
}

function compareDates(a, b) {
  return a - b;
}

function ensureDateObj(x) {
  if (!(x instanceof Date)) x = new Date(x);

  return x;
}

function containsDate(dateArr, dateObj) {
  return dateArr.some(function (d) {
    return compareDates(d, dateObj) === 0;
  });
}

function findNextDate(sortedDateArr, dateObj) {
  return sortedDateArr.find(function (d) {
    return compareDates(d, dateObj) > 0;
  });
}

function todayDate() {
  var d = void 0;

  if (queryParams && queryParams.today) {
    d = new Date(queryParams.today);
  } else {
    d = new Date();
    d.setHours(0, 0, 0, 0);
  }

  return d;
}

function longDate(d) {
  var localeOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  return d.toLocaleString('en-us', localeOptions);
}

var ANSWERS = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  YES: 'Yes',
  NO: 'No',
  UNKNOWN: '?'
});

var COLOR_CLASSES = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  POSITIVE: 'text-color-positive',
  NEGATIVE: 'text-color-negative',
  NEUTRAL: 'text-color-neutral'
});

var NEXT_DATE_UNKNOWN = '?';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Bagels',
  data: function data() {
    return {
      remoteData: '',
      dataError: false,
      remoteUrl: 'https://us-central1-bagels-today.cloudfunctions.net/bagelData',
      exampleUrl: '/static/example.json'
    };
  },
  mounted: function mounted() {
    var _this = this;

    axios.get(this.dataUrl).then(function (response) {
      if (!_this.dataError) _this.remoteData = response.data;
    }).catch(function (err) {
      _this.dataError = true;
      console.error(err);
    });

    setTimeout(function () {
      if (_this.isAwaitingData) {
        _this.dataError = true;
        console.error('Request for bagel data timed out and could not be completed');
      }
    }, 10000);
  },

  computed: {
    dataUrl: function dataUrl() {
      var dataUrl = this.remoteUrl;

      if (queryParams && queryParams.example) {
        dataUrl = this.exampleUrl;
      }

      return dataUrl;
    },
    bagelDateObjs: function bagelDateObjs() {
      var rawData = [];

      if (this.remoteData) {
        rawData = this.remoteData.values[0];
      }

      var bagelDateObjs = rawData.map(function (d) {
        return d.trim();
      }).filter(function (d) {
        return d;
      }).map(function (d) {
        return ensureDateObj(d);
      });

      bagelDateObjs.sort(compareDates);

      return bagelDateObjs;
    },
    isAwaitingData: function isAwaitingData() {
      return !this.dataError && !this.remoteData;
    },
    nextDateVal: function nextDateVal() {
      return findNextDate(this.bagelDateObjs, todayDate());
    },
    answerVal: function answerVal() {
      var isDefinitelyBagelDay = containsDate(this.bagelDateObjs, todayDate()),
          answerVal = void 0;

      if (isDefinitelyBagelDay) answerVal = 'YES';else if (this.nextDateVal) answerVal = 'NO';else answerVal = 'UNKNOWN';

      return answerVal;
    },
    answerColorClass: function answerColorClass() {
      var colorMappings = {
        YES: 'POSITIVE',
        NO: 'NEGATIVE',
        UNKNOWN: 'NEUTRAL'
      },
          colorKey = colorMappings[this.answerVal],
          colorClass = COLOR_CLASSES[colorKey];

      return colorClass;
    },
    nextDateColorClass: function nextDateColorClass() {
      var colorClass = COLOR_CLASSES['NEUTRAL'];

      if (this.nextDateVal) colorClass = COLOR_CLASSES['POSITIVE'];

      return colorClass;
    },
    answerContent: function answerContent() {
      return ANSWERS[this.answerVal];
    },
    nextDateContent: function nextDateContent() {
      var nextDateContent = void 0;

      if (this.nextDateVal) nextDateContent = longDate(this.nextDateVal);else nextDateContent = NEXT_DATE_UNKNOWN;

      return nextDateContent;
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Bagels__ = __webpack_require__("MAiX");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/feedback',
    name: 'Feedback',
    beforeEnter: function beforeEnter(to, from, next) {
      window.location.href = 'https://docs.google.com/forms/d/e/1FAIpQLSd0JUf8bflT_OdNdR9K7ViMsUY5pJIMtaUuMKMFPaBDjE_U3g/viewform';
    }
  }, {
    path: '/future',
    name: 'Future',
    beforeEnter: function beforeEnter(to, from, next) {
      window.location.href = 'https://trello.com/b/Qvq8z8aC/bagels-today';
    }
  }, {
    path: '/list',
    name: 'List',
    beforeEnter: function beforeEnter(to, from, next) {
      window.location.href = 'https://docs.google.com/spreadsheets/d/1IufK0RGbgUhmy7ISVVoEj5HVEU8y5mxpLGBD9x5ALZk/edit?usp=sharing';
    }
  }, {
    path: '/',
    name: 'Bagels',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Bagels__["a" /* default */]
  }]
}));

/***/ }),

/***/ "wuJh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cfab3af3206e3e4a6acd.js